//import LocomotiveScroll from 'locomotive-scroll';
import { gsap, TweenLite, TweenMax, Linear, Back, Elastic, TimelineMax, TimelineLite, Power1, Power4 , Power2, Power3} from "gsap";
import { CSSRulePlugin } from "gsap/CSSRulePlugin";
import { Draggable } from "gsap/Draggable";
import { SplitText } from "gsap/SplitText";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { CustomEase } from "gsap/CustomEase";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import barba from '@barba/core';
import 'slick-carousel';
import * as mousemove from "./mousemove.js";
import * as scroll from "./scroll.js";
import * as loader from "./loader.js";
import * as page from "./page.js";
import * as typeWriter from "./typewriter.js";
import * as overlay from "./overlay.js";
import * as menu from "./menu.js";

gsap.registerPlugin(CSSRulePlugin, Draggable, SplitText,ScrollToPlugin, ScrollTrigger, MorphSVGPlugin, CustomEase, InertiaPlugin, TweenMax);





function appReady(){
	/*var url = "/wp-content/themes/vb/assets/css/style.css",
    head = document.getElementsByTagName('head')[0],
    ElmainCss = document.createElement('link');

	ElmainCss.type = "text/css"; 
	ElmainCss.rel = "stylesheet";
	ElmainCss.href = url;

	head.appendChild(ElmainCss);

			
	if (ElmainCss.addEventListener) {
		ElmainCss.addEventListener('load', function() {
			
		}, false);   
	};*/
	initApp();
}

appReady();


var scrollbar;
var Scrollbar = window.Scrollbar;
var options = {
	"continuousScrolling": true
};
scrollbar = Scrollbar.init(document.querySelector('#smooth-scroll'), options);

scrollbar.addListener(function (e) {
	scroll.update(e);
});






function initApp(){

	//if (!mobileCheck()) {
	//	$("#site-cursor").addClass("show");
	//	$("body").addClass("hide-cursor");
	//}
	//$("#page__content").removeClass("blur");
	//$("#page-" + page).addClass("show");
	mousemove.init();
	loader.init();
	setTimeout(function(){
		page.enterAnimation($(".smooth-scroll"));
		initPage();
	},3000); //3000

	
	

	
}

function initPage(){
	var pageName = $(".smooth-scroll").attr("page");
	page.callback(pageName);
	
	scrollbar.scrollTo(0, 0, 0);
	//scroll.init();
	if($(".slider").length){
		initSliders();
	}
	if($("#page-apenzaken").length){
		apenzakenLandingAnimation();
	}
	

}












function initSliders(){
	$('.slider').on('init', function(event, slick){
		
		
	});
	$('.slider').slick({
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		dots:false,
		arrows:false,
		centerMode:true,
		variableWidth:true,
		adaptiveHeight: true

	});
}



barba.init({
	transitions: [{
		name: 'opacity-transition',
		sync: false,
		leave(data) {
			return page.leaveAnimation(data.current.container);
			
			
		},
		enter(data) {
			
			
		},
		after(data) {
			initPage();
			return page.enterAnimation(data.next.container);
			
			
			
			
			//return gsap.to($(data.next.container),{ y: 0, duration:0.5, delay:0,ease: Power3.easeOut});
			//initScroll();
			//initDefault();
			//initSplitText();
			//initSliders();
			//initParallax();
			//bgColorScroll();
			//initLinks();
			//enterPageAnimation(nextEl);
		}
	}],

	
});

function apenzakenLandingAnimation(){
	
	
	gsap.to($("#page-apenzaken"), {opacity:1,duration:1,ease: Power1.easeIn});
	var slide1 = $("#apenzaken-landing #slide-1");
	var slide2 = $("#apenzaken-landing #slide-2");

	var delay = 800;
	setTimeout(function(){
		gsap.to($(".rotating", $(slide1)), {rotate:"2160deg", delay:0.8, duration:3,ease: Power1.easeIn});
		gsap.to($(slide2), {opacity:1, duration:1, delay:2.8});
		gsap.to($(".rotating", $(slide2)), {rotate:"2160deg", delay:2, duration:3, ease: Power1.easeOut});
		$(".line",$(slide2)).each(function(i,v){
			gsap.to($(v), {height:"1em", delay:2.5, duration:1.5, ease: Power3.easeInOut});
		});
	}, delay);
	
	
	
	

	
}

	

window.mobileCheck = function () {
	let check = false;
	(function (a) {
		if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
	})(navigator.userAgent || navigator.vendor || window.opera);
	return check;
};






